var _path, _polygon, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAigLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 213 108",
    viewBox: "0 0 213 108",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primaryBrand",
    d: "M51.6,40.4l9,20.6H42.2L51.6,40.4z M50,23.7L21.8,84.3h9.9l6.8-14.7h26l6.4,14.7h10L53.5,23.7H50z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "primaryBrand",
    points: "99.4,84.3 90.3,84.3 90.3,23.7 99.4,23.7 99.4,80.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "primaryBrand",
    d: "M147.4,52.8h25.1v2c0,4.6-0.5,8.6-1.6,12.1c-1,3.2-2.8,6.3-5.3,9.1c-5.6,6.3-12.8,9.5-21.5,9.5 c-8.5,0-15.7-3.1-21.8-9.2c-6-6.2-9.1-13.5-9.1-22.1c0-8.8,3.1-16.3,9.2-22.4c6.2-6.2,13.6-9.2,22.5-9.2c4.7,0,9.2,1,13.3,2.9 c3.9,1.9,7.8,5.1,11.6,9.4l-6.5,6.2c-5-6.6-11-9.9-18.2-9.9c-6.4,0-11.8,2.2-16.1,6.6c-4.3,4.3-6.5,9.8-6.5,16.3 c0,6.8,2.4,12.3,7.3,16.7c4.5,4.1,9.4,6.1,14.7,6.1c4.5,0,8.5-1.5,12.1-4.5c3.6-3.1,5.6-6.7,6-11h-15.1V52.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "primaryBrand",
    d: "M8.3,8.3h183.1v91.3H8.3V8.3z M0,108h199.7V0H0V108z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "primaryBrand",
    d: "M209.2,99.4c2.3,0,4.2,1.8,4.2,4.2c0,2.4-1.9,4.2-4.2,4.2c-2.3,0-4.3-1.8-4.3-4.2 C205,101.2,206.9,99.4,209.2,99.4 M209.2,107.2c2,0,3.5-1.6,3.5-3.6c0-2-1.5-3.6-3.5-3.6c-2,0-3.5,1.6-3.5,3.6 C205.7,105.7,207.2,107.2,209.2,107.2 M207.6,101.1h1.9c1.2,0,1.7,0.5,1.7,1.4c0,0.9-0.6,1.3-1.3,1.3l1.4,2.2h-0.8l-1.4-2.1h-0.8 v2.1h-0.8V101.1z M208.3,103.3h0.8c0.7,0,1.3,0,1.3-0.8c0-0.7-0.6-0.8-1.1-0.8h-1V103.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAigLogoW);
export default __webpack_public_path__ + "static/media/aig-logo_w.e98aa9cdbba08101388175d0275aa042.svg";
export { ForwardRef as ReactComponent };